import { defineMessages } from "react-intl";

const messages = defineMessages({
  label: {
    defaultMessage: "Preview",
    description: "indicator that feature is in preview mode"
  },
  tooltip: {
    defaultMessage:
      "This feature is in a preview state and can be subject to changes at later point",
    description: "tooltip"
  }
});

export default messages;
